export default class Box {
  public length?: number | null = null;
  public label?: string = "";
  public width?: number | null = null;
  public height?: number | null = null;
  public weight?: number | null = null;
  public contents?: any; // packageCategory option Object
  public marketValue: number | null = null;
  public premiumProtection?: any;
  public sortOrder?: number;
  public preset?: string; // name of preset
  public safeDimensions?: boolean;
  public insideDescription?: string; // TO DO soon: get rid of the description array in the store's contents
  public outsideDescription?: string; // TO DO soon: get rid of the description array in the store's contents
  public hasOverMaxPackage?: boolean;
  public commodityCurrencyCode?: string;
  public commodityDuty?: number;
  public commodityId?: string;
  public hsCode?: string;
  public isCalculable?: boolean;
  public productId?: string;
  public totalCommodityDutyAndTax?: number;
  public totalCommodityTaxesAndFee?: number;

  public errors!: {
    lengthInvalid?: boolean;
    widthInvalid?: boolean;
    heightInvalid?: boolean;
    weightInvalid?: boolean;
    dimensionalInvalid?: boolean;
    categorySelectionInvalid?: boolean;
    marketValueInvalid?: boolean;
    premiumProtectionInvalid?: boolean;
    nameSelectionInvalid?: boolean;
  };

  public constructor(init?: Partial<Box>) {
    Object.assign(this, init);
    if (!init?.contents) {
      this.contents = {}
    }
    if (!init?.premiumProtection) {
      this.premiumProtection = {}
    }
    this.errors = {
      lengthInvalid: false,
      widthInvalid: false,
      heightInvalid: false,
      weightInvalid: false,
      dimensionalInvalid: false,
      categorySelectionInvalid: false,
      marketValueInvalid: false,
      premiumProtectionInvalid: false,
      nameSelectionInvalid: false,
    };
  }
}
